import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"

import rootReducer from "./slices"

const middleware = [...getDefaultMiddleware()]
const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== "production"
})

export * from "./helpers"
export * from "./slices"

export default store
